import React from 'react';
import './Contacts.scss';

const Contacts = () => (
	<div className="contacts-section">
		<div className="contacts__title">
			Наши контакты
		</div>
		<div className="contacts__subtitle">
			Обращайтесь в службу поддержки клиентов LG по всем вопросам, касающимся нашей продукции.
		</div>
		<div className="contacts__cols">
			<div className="contact__cols__item">
				<a href="/ru/support/email" target="_blank" title="Открывается в новом окне" className="contact__link">
					<div className="contact__icon">
						<img src={process.env.PUBLIC_URL + '/ru-home-linkicon-1.jpg'} alt="" />
					</div>
					<div className="contact__title">
						E-mail
					</div>
					<div className="contact__text">
						Отправить сообщение по электронной почте
					</div>
				</a>
			</div>
			<div className="contact__cols__item">
				<div className="contact__icon">
					<img src={process.env.PUBLIC_URL + '/ru-home-linkicon-2.jpg'} alt="" />
				</div>
				<div className="contact__title">
					Телефон
				</div>
				<div className="contact__text">
					Пожалуйста, позвоните в службу поддержки по телефонам
					<br /><a href="tel:84996777676">8(499) 677-76-76 (Москва и МО)</a>
					<br /><a href="tel:88002007676">8(800) 200-76-76 (Россия)</a>
					<br /><a href="tel:882000711111">8(820) 0071-1111 (Беларусь)</a>
					<br />Круглосуточно, 365 дней в году
				</div>
			</div>
			<div className="contact__cols__item">
				<a href="/ru/support/chat-email" className="contact__link">
					<div className="contact__icon">
						<img src={process.env.PUBLIC_URL + '/ru-home-linkicon-3.jpg'} alt="" />
					</div>
					<div className="contact__title">
						Онлайн-чат
					</div>
					<div className="contact__text">
						с 9:00 до 18:00, 365 дней в году
						<br />Пожалуйста, воспользуйтесь
						<br />онлайн-чатом для общения со специалистами службы поддержки
					</div>
				</a>
			</div>
			<div className="contact__cols__item">
				<div className="contact__icon">
					<img src={process.env.PUBLIC_URL + '/ru-home-linkicon-4.jpg'} alt="" />
				</div>
				<div className="contact__title">
					Фирменный магазин LG
				</div>
				<div className="contact__text">
					Телефоны:
					<br />8 (495) 150-65-35
					<br />8 (800) 500-65-35
					<br />Время работы:
					<br />пн-вс 10-23
					<br />
					<br />
					<br />
					<a href="/ru/shop"><u>Москва, ТРЦ Метрополис,
						<br />Ленинградское шоссе 16а стр 4
						<br />вход со стороны м.Балтийская</u>
					</a>
				</div>
			</div>
		</div>
	</div>
);

export default Contacts;